export default "__VITE_ASSET__BFU8Jmkv__"